import { Routes } from '@angular/router';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { FleetComponent } from './fleet.component';
import { DriverComponent } from './driver/driver.component';
import { VehicleComponent } from './vehicle/vehicle.component';
import { EditDriverComponent } from './driver/edit-driver/edit-driver.component';
import { EditVehicleComponent } from './vehicle/edit-vehicle/edit-vehicle.component';
import { ViewDriverComponent } from './driver/view-driver/view-driver.component';
import { ViewVehicleComponent } from './vehicle/view-vehicle/view-vehicle.component';
import { TrailerListComponent } from './trailer/trailer-list/trailer-list.component';
import { TrailerFormComponent } from './trailer/trailer-form/trailer-form.component';
import { TrailerViewComponent } from './trailer/trailer-view/trailer-view.component';
import { TrailerTypeListComponent } from './trailer/trailer-type-list/trailer-type-list.component';
import { TrailerTypeFormComponent } from './trailer/trailer-type-form/trailer-type-form.component';
import { TrailerTypeViewComponent } from './trailer/trailer-type-view/trailer-type-view.component';
import { MobilizationShellComponent } from './mobilization/shell/mobilization-shell.component';
import { MobilizationOverviewComponent } from './mobilization/overview/mobilization-overview.component';
import { MobilizationCreateComponent } from './mobilization/create/mobilization-create.component';
import { MobilizationChangeRequestsComponent } from './mobilization/change-requests/mobilization-change-requests.component';
import { MobilizationEntriesComponent } from './mobilization/entries/mobilization-entries.component';
import { MobilizationHistoryComponent } from './mobilization/history/mobilization-history.component';
import { MobilizationTimesheetGridComponent } from './mobilization/timesheet-grid/mobilization-timesheet-grid.component';
import { MobilizationDetailComponent } from './mobilization/detail/mobilization-detail.component';
import { MobilizationPlanningComponent } from './mobilization/planning/mobilization-planning.component';
import { SalaryRuleListComponent } from './mobilization/salary-rules/salary-rule-list/salary-rule-list.component';
import { SalaryRuleFormComponent } from './mobilization/salary-rules/salary-rule-form/salary-rule-form.component';
import { SalaryRuleViewComponent } from './mobilization/salary-rules/salary-rule-view/salary-rule-view.component';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { MaintenanceShellComponent } from './maintenance/shell/maintenance-shell.component';
import { MaintenanceWorkspaceComponent } from './maintenance/workspace/maintenance-workspace.component';
import { FleetBulkUploadComponent } from './bulk-upload/fleet-bulk-upload.component';
import { GpsTrackingWorkspaceComponent } from './gps-tracking/gps-tracking-workspace.component';
import { FleetDocumentsComponent } from './documents/fleet-documents.component';
import { FleetProfitabilityComponent } from './profitability/fleet-profitability.component';
import { TruckProfitabilityComponent } from './truck-profitability/truck-profitability.component';
import { RentalOverviewComponent } from './rental/overview/rental-overview.component';
import { RentalAgreementListComponent } from './rental/agreements/list/rental-agreement-list.component';
import { RentalAgreementFormComponent } from './rental/agreements/form/rental-agreement-form.component';
import { RentalAgreementDetailComponent } from './rental/agreements/detail/rental-agreement-detail.component';
import { RentalUsageComponent } from './rental/usage/rental-usage.component';
import { RentalSettlementsComponent } from './rental/settlements/rental-settlements.component';

export const fleetRoutes: Routes = [
    {
        path: 'fleet',
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: { enterpriseModules: ['FLEET'], enterpriseFeatureLabel: 'Fleet' },
        children: [
            {
                path: '',
                component: FleetComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.dashboard.view, scope: 'ANY' }
            },
            {
                path: 'drivers',
                component: DriverComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.drivers.view }
            },
            {
                path: 'driver/create',
                component: EditDriverComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.drivers.create }
            },
            {
                path: 'driver/view/:id',
                component: ViewDriverComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.drivers.view }
            },
            {
                path: 'driver/edit/:id',
                component: EditDriverComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.drivers.edit }
            },
            {
                path: 'vehicles',
                component: VehicleComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.view }
            },
            {
                path: 'rentals',
                component: RentalOverviewComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.rental.view }
            },
            {
                path: 'rentals/agreements',
                component: RentalAgreementListComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.rental.view }
            },
            {
                path: 'rentals/agreements/new',
                component: RentalAgreementFormComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.rental.manage }
            },
            {
                path: 'rentals/agreements/:id/edit',
                component: RentalAgreementFormComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.rental.manage }
            },
            {
                path: 'rentals/agreements/:id',
                component: RentalAgreementDetailComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.rental.view }
            },
            {
                path: 'rentals/usage',
                component: RentalUsageComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.rental.usage.view }
            },
            {
                path: 'rentals/settlements',
                component: RentalSettlementsComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.rental.settlement.view }
            },
            {
                path: 'documents',
                component: FleetDocumentsComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.documents.view }
            },
            {
                path: 'profitability',
                component: FleetProfitabilityComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.profitability.view }
            },
            {
                path: 'truck-profitability',
                component: TruckProfitabilityComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.profitability.view }
            },
            {
                path: 'bulk-upload',
                component: FleetBulkUploadComponent,
                canActivate: [PermissionGuard],
                data: { permission: [app_permissions.fleet.drivers.create, app_permissions.fleet.vehicles.create] }
            },
            {
                path: 'vehicle/edit/:id',
                component: EditVehicleComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.edit }
            },
            {
                path: 'vehicle/view/:id',
                component: ViewVehicleComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.view }
            },
            {
                path: 'vehicle/create',
                component: EditVehicleComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.create }
            },
            {
                path: 'vehicle/telematics/:vehicleId',
                redirectTo: 'gps/vehicles/:vehicleId',
                pathMatch: 'full'
            },
            {
                path: 'gps',
                component: GpsTrackingWorkspaceComponent,
                canActivate: [PermissionGuard],
                data: {
                    permission: app_permissions.fleet.telematics.view,
                    enterpriseModules: ['GPS_TRACKING'],
                    enterpriseFeatureLabel: 'GPS Tracking',
                    page: 'live'
                }
            },
            {
                path: 'gps/vehicles/:vehicleId/history',
                component: GpsTrackingWorkspaceComponent,
                canActivate: [PermissionGuard],
                data: {
                    permission: app_permissions.fleet.telematics.view,
                    enterpriseModules: ['GPS_TRACKING'],
                    enterpriseFeatureLabel: 'GPS Tracking',
                    page: 'history'
                }
            },
            {
                path: 'gps/vehicles/:vehicleId',
                component: GpsTrackingWorkspaceComponent,
                canActivate: [PermissionGuard],
                data: {
                    permission: app_permissions.fleet.telematics.view,
                    enterpriseModules: ['GPS_TRACKING'],
                    enterpriseFeatureLabel: 'GPS Tracking',
                    page: 'vehicle'
                }
            },
            {
                path: 'gps/providers',
                component: GpsTrackingWorkspaceComponent,
                canActivate: [PermissionGuard],
                data: {
                    permission: app_permissions.fleet.telematics.manage,
                    enterpriseModules: ['GPS_TRACKING'],
                    enterpriseFeatureLabel: 'GPS Tracking',
                    page: 'providers'
                }
            },
            {
                path: 'gps/mappings',
                component: GpsTrackingWorkspaceComponent,
                canActivate: [PermissionGuard],
                data: {
                    permission: app_permissions.fleet.telematics.manage,
                    enterpriseModules: ['GPS_TRACKING'],
                    enterpriseFeatureLabel: 'GPS Tracking',
                    page: 'mappings'
                }
            },
            {
                path: 'gps/geofences',
                component: GpsTrackingWorkspaceComponent,
                canActivate: [PermissionGuard],
                data: {
                    permission: app_permissions.fleet.telematics.manage,
                    enterpriseModules: ['GPS_TRACKING'],
                    enterpriseFeatureLabel: 'GPS Tracking',
                    page: 'geofences'
                }
            },
            {
                path: 'gps/alerts',
                component: GpsTrackingWorkspaceComponent,
                canActivate: [PermissionGuard],
                data: {
                    permission: app_permissions.fleet.telematics.manage,
                    enterpriseModules: ['GPS_TRACKING'],
                    enterpriseFeatureLabel: 'GPS Tracking',
                    page: 'alerts'
                }
            },
            {
                path: 'gps/reports',
                component: GpsTrackingWorkspaceComponent,
                canActivate: [PermissionGuard],
                data: {
                    permission: app_permissions.fleet.telematics.view,
                    enterpriseModules: ['GPS_TRACKING'],
                    enterpriseFeatureLabel: 'GPS Tracking',
                    page: 'reports'
                }
            },
            {
                path: 'trailer-types',
                component: TrailerTypeListComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.view }
            },
            {
                path: 'trailer-type/create',
                component: TrailerTypeFormComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.create }
            },
            {
                path: 'trailer-type/edit/:id',
                component: TrailerTypeFormComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.edit }
            },
            {
                path: 'trailer-type/view/:id',
                component: TrailerTypeViewComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.view }
            },
            {
                path: 'trailers',
                component: TrailerListComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.view }
            },
            {
                path: 'trailer/create',
                component: TrailerFormComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.create }
            },
            {
                path: 'trailer/edit/:id',
                component: TrailerFormComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.edit }
            },
            {
                path: 'trailer/view/:id',
                component: TrailerViewComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.vehicles.view }
            },
            {
                path: 'mobilization',
                component: MobilizationShellComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.mobilization.records.view },
                children: [
                    {
                        path: '',
                        component: MobilizationOverviewComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.overview.view }
                    },
                    {
                        path: 'overview',
                        pathMatch: 'full',
                        redirectTo: ''
                    },
                    {
                        path: 'entries',
                        component: MobilizationEntriesComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.records.view }
                    },
                    {
                        path: 'planning',
                        component: MobilizationPlanningComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.overview.view }
                    },
                    {
                        path: 'new',
                        component: MobilizationCreateComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.records.create }
                    },
                    {
                        path: 'edit/:id',
                        component: MobilizationCreateComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.records.edit }
                    },
                    {
                        path: 'change-requests',
                        component: MobilizationChangeRequestsComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.change_requests.view }
                    },
                    {
                        path: 'change-requests/:id',
                        component: MobilizationDetailComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.change_requests.view }
                    },
                    {
                        path: 'history',
                        component: MobilizationHistoryComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.history.view }
                    },
                    {
                        path: 'timesheet-grid',
                        component: MobilizationTimesheetGridComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.timesheets.view }
                    },
                    {
                        path: 'salary-rules',
                        component: SalaryRuleListComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.records.view }
                    },
                    {
                        path: 'salary-rules/new',
                        component: SalaryRuleFormComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.records.create }
                    },
                    {
                        path: 'salary-rules/edit/:id',
                        component: SalaryRuleFormComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.records.edit }
                    },
                    {
                        path: 'salary-rules/:id',
                        component: SalaryRuleViewComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.records.view }
                    },
                    {
                        path: ':id',
                        component: MobilizationDetailComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.mobilization.records.view }
                    }
                ]
            },
            {
                path: 'maintenance',
                component: MaintenanceShellComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.fleet.maintenance.overview.view },
                children: [
                    {
                        path: '',
                        component: MaintenanceWorkspaceComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.maintenance.overview.view, page: 'overview' }
                    },
                    {
                        path: 'work-orders',
                        component: MaintenanceWorkspaceComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.maintenance.work_orders.view, page: 'work-orders' }
                    },
                    {
                        path: 'work-orders/:id',
                        component: MaintenanceWorkspaceComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.maintenance.work_orders.view, page: 'work-orders' }
                    },
                    {
                        path: 'requests/:id',
                        component: MaintenanceWorkspaceComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.maintenance.requests.view, page: 'overview' }
                    },
                    {
                        path: 'preventive',
                        component: MaintenanceWorkspaceComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.maintenance.programs.view, page: 'preventive' }
                    },
                    {
                        path: 'inspections',
                        component: MaintenanceWorkspaceComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.maintenance.inspections.view, page: 'inspections' }
                    },
                    {
                        path: 'defects/:id',
                        component: MaintenanceWorkspaceComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.maintenance.defects.view, page: 'inspections' }
                    },
                    {
                        path: 'parts',
                        component: MaintenanceWorkspaceComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.maintenance.parts.view, page: 'parts' }
                    },
                    {
                        path: 'availability',
                        component: MaintenanceWorkspaceComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.maintenance.availability.view, page: 'availability' }
                    },
                    {
                        path: 'analytics',
                        component: MaintenanceWorkspaceComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.maintenance.analytics.view, page: 'analytics' }
                    },
                    {
                        path: 'vehicle-profile/:vehicleId',
                        component: MaintenanceWorkspaceComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.fleet.maintenance.overview.view, page: 'vehicle-profile' }
                    }
                ]
            }
        ]
    }
];
